import React from 'react';
import { Box, MenuItem, TextField } from '@mui/material';
import useTranslations from 'hooks/useTranslations';
import { useEisRuleConfigContext } from '../context';

const TIME_WINDOW_OPTIONS = [
  { value: 30, key: '30days' },
  { value: 60, key: '60days' },
  { value: 90, key: '90days' },
  { value: 180, key: '180days' },
  { value: 365, key: '1year' },
] as const;

const SCORE_MIN = 1;
const SCORE_MAX = 500;

const ThresholdSection: React.FC = () => {
  const t = useTranslations();
  const { scoreThreshold, setScoreThreshold, windowDays, setWindowDays } = useEisRuleConfigContext();

  return (
    <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
      <TextField
        type='number'
        label={t('performanceReporting.eis.configuration.configureThreshold.threshold.scoreLabel')}
        value={scoreThreshold ?? ''}
        onChange={(e) => {
          const raw = e.target.value;
          if (raw === '') {
            setScoreThreshold(null);
            return;
          }
          const parsed = parseInt(raw, 10);
          if (!isNaN(parsed)) {
            setScoreThreshold(Math.min(SCORE_MAX, Math.max(SCORE_MIN, parsed)));
          }
        }}
        inputProps={{ min: SCORE_MIN, max: SCORE_MAX }}
        size='medium'
        sx={{ flex: 1 }}
      />

      <TextField
        select
        label={t('performanceReporting.eis.configuration.configureThreshold.threshold.timeWindowLabel')}
        value={windowDays ?? ''}
        onChange={(e) => {
          const val = e.target.value;
          setWindowDays(val === '' ? null : (Number(val) as typeof windowDays));
        }}
        size='small'
        sx={{ flex: 1 }}
      >
        {TIME_WINDOW_OPTIONS.map((opt) => (
          <MenuItem
            key={opt.value}
            value={opt.value}
          >
            {t(`performanceReporting.eis.configuration.configureThreshold.threshold.timeWindow.${opt.key}`)}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
};

export default ThresholdSection;
